<template>
    <div class="home-buttons">
        <v-card flat class="mt-2">
            <v-container>
                <v-layout row justify-center align-center>
                    <v-flex class="text-center">
                        <v-btn depressed icon fab to="/categories">
                            <img style="max-width: 100%; height: auto" src="https://digima.sgp1.digitaloceanspaces.com/mybarko/lp-icons/categories.svg"
                                alt="">
                        </v-btn>
                        <div class="font-weight-medium caption">Categories</div>
                    </v-flex>
                    <!--<v-flex class="text-center">-->
                        <!--<v-btn flat depressed icon fab to="mybarko-shop">-->
                            <!--<img style="max-width: 100%; height: auto" src="https://digima.sgp1.digitaloceanspaces.com/mybarko/lp-icons/market.svg"-->
                                <!--alt="">-->
                        <!--</v-btn>-->
                        <!--<div class="min-height-42 font-weight-medium caption">MyBarko Market</div>-->
                    <!--</v-flex>-->
                    <!-- <v-flex class="text-center">
                        <v-btn flat depressed icon fab to="/rewards">
                            <img style="max-width: 100%; height: auto" src="https://digima.sgp1.digitaloceanspaces.com/mybarko/lp-icons/rewards.svg"
                                alt="">
                        </v-btn>
                        <div class="min-height-42 font-weight-medium caption">Rewards</div>
                    </v-flex>
                    <v-flex class="text-center">
                        <v-btn flat depressed icon fab to="/multi-wallet">
                            <img style="max-width: 100%; height: auto" src="https://digima.sgp1.digitaloceanspaces.com/mybarko/lp-icons/wallet.svg"
                                alt="">
                        </v-btn>
                        <div class="min-height-42 font-weight-medium caption">Multi-Wallet</div>
                    </v-flex>
                    <v-flex class="text-center">
                        <v-btn flat depressed icon fab to="/raffle">
                            <img style="max-width: 100%; height: auto" src="../assets/icons/raffle.svg"
                                alt="">
                        </v-btn>
                        <div class="min-height-42 font-weight-medium caption">Raffle</div>
                    </v-flex> -->
                </v-layout>
            </v-container>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                dialog: false,
                notifications: false,
                sound: true,
                widgets: false
            }
        },
        methods: {
            redirectToHome(id) {
                this.$router.push({
                    path: '/',
                })
            },
            categoriesDialog() {
                this.dialog = true;
                EventBus.$emit('categoriesDialog', true);
            },
        }
    }

</script>
